import { Injectable } from "@angular/core";
import { AppRouterService } from "../services/app-router.service";
import { NavigationEnd, Router, RoutesRecognized } from "@angular/router";
import { filter } from "rxjs";
import { ProcessShellService } from "../process-shell/services/process-shell.service";
import { CBXDialogData } from "../fpx-core/services/dialog/dialog.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "../fpx-core/dialogs/confirmation-dialog/confirmation-dialog.component";

@Injectable({
    providedIn: 'root'
})

export class ShellService {
    private _routerHistory: any[] = [];
    private _currentPath: string = '';
    private _isBack: boolean = false;

    constructor(
        private _routingService: AppRouterService,
        private _router: Router,
        private _processShellService: ProcessShellService,
        private _dialog: MatDialog 
    ) {
        this._router.events
            .pipe(
                filter(
                    (event): event is NavigationEnd => event instanceof NavigationEnd
                )
            )
            .subscribe({
                next: (res) => {
                    if (this._currentPath && this._currentPath != '/onboarding/process-shell/rcob/rm-applicant-info' && this._processShellService.getBodNumber() != 2) {
                        this._routerHistory.push({
                            path: this._currentPath.split(',')
                        });
                    }

                    this._currentPath = res.url;
                },
            });
    }

    onFormLoad($event) {

    }

    goBack() {
        this._currentPath = null;

        if(this._routerHistory.length){
            let backNav = this._routerHistory.pop();
            this._router.navigate(backNav.path, {
                queryParams:{}
            });
        } else{
            this.goHome();
        }
    }

    goHome(){
        let _data: CBXDialogData = {
            icon: 'Exit-application',
            title: 'Resume Later',
            message: 'Do you want to close the window and resume your application later?',
            okLabel: 'Yes',
            cancelLabel: 'No'
        }
        let dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            data: _data,
            // panelClass: ['alert-dialog','alert-modal'],
            panelClass: ['confirmation-dialog','confirmation-modal'],
            backdropClass: 'confirmation-dialog-backdrop',
            hasBackdrop: true
        });
        dialogRef.afterClosed().subscribe(action => {
            if(action == 1) {
                console.log('go home');
                this._currentPath = null;
                this._routerHistory = [];
                this._router.navigate(['rm-home']);
            } else {
                
            }
        });
        
    }
}
